import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { persistor } from "../../../app/store/store";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Topbar from "./Topbar/Topbar";
import Sidebar from "./Sidebar/Sidebar";
import Main from "./Main/Main";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import { ResetPasswordModalContent } from "../../../features/common/ResetPasswordModal/ResetPasswordModalContent";
import { generateDynamicProtectedRoutes } from "../../../routes/protectedRoutes/generateDynamicProtectedRoutes";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const CommonPage = ({ enabledRole }) => {
  //Selected from redux
  const role = useSelector((state) => state.app.role);
  const subRole = useSelector((state) => state.app.subRole);
  const appConfig = useSelector((state) => state.app.appConfig);
  const resetPasswordRequired = useSelector(
    (state) => state.app.rstPasswordRequired
  );

  const [open, setOpen] = useState(true);

  // Hooks
  const navigate = useNavigate();

  if (![role, subRole].includes(enabledRole)) {
    console.error("not allowed!");
    persistor.purge();
    navigate("/login");
    window.location.reload();
  }

  return (
    <Box className="flex h-full w-full">
      {resetPasswordRequired && (
        <CoreModal
          width={500}
          height={600}
          state={resetPasswordRequired !== "False"}
          onClose={null}
          component={<ResetPasswordModalContent role={role} />}
        />
      )}
      <div className="">
        {" "}
        <Topbar
          routes={generateDynamicProtectedRoutes(enabledRole, appConfig)}
          open={open}
          setOpen={setOpen}
        />
        <Sidebar
          routes={generateDynamicProtectedRoutes(enabledRole, appConfig)}
          open={open}
          setOpen={setOpen}
          DrawerHeader={DrawerHeader}
          role={enabledRole}
        />
      </div>

      <div className="w-full">
        <Main DrawerHeader={DrawerHeader} />
      </div>
    </Box>
  );
};

export default CommonPage;
